export function productRouteId(id) {
  return String(id || '').split('/').pop();
}

export function productPath(id) {
  return `/products/${productRouteId(id)}`;
}

export function customOptionPath(productId, groupId) {
  return `${productPath(productId)}/add-ons/${encodeURIComponent(groupId)}`;
}

export function collectionPath(id) {
  return `/collections/${productRouteId(id)}/sorting`;
}
